module.exports = __webpack_public_path__ + "static/buehne_leistungen-a8ab08bd30759984d539148d11b163aa.svg";